<template>
  <div class="notification-message-block mb-16 base-card-wrapper">
    <div class="sub-card-wrapper">
      <BaseListItemCard
        size="sm"
        class="card-container"
      >
        <div class="flex flex-col content-container">
          <div class="top-section">
            <div class="flex items-start justify-between mb-2">
              <div class="flex items-center gap-3">
                {{ title }}
              </div>

              <div class="flex items-center gap-2">
                <div
                  style="height: 15px; width:15px"
                  v-if="unread"
                  class="rounded-full bg-amber-400"
                  aria-label="Непрочитане повідомлення"
                ></div>
                <span class="text-sm grey-3-color">{{ formattedDate }}</span>
              </div>
            </div>
            <p v-safe-html="message"
               :class="[
     textSize,
     'grey-3-color mt-1',
     {'red-1-color': isError}
   ]"
               style="padding-bottom: 12px" />
          </div>

          <div class="pb-4"></div>
        </div>
      </BaseListItemCard>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotificationMessage",

  props: {
    textSize: {
      type: String,
      default: "text-base-span-md"
    },
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    date: {
      type: [String, Date],
      required: true
    },
    unread: {
      type: Boolean,
      default: false
    },
    isError: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    formattedDate() {
      if (!this.date) return "";

      const date = new Date(this.date);
      return date.toLocaleString("uk-UA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
      });
    }
  }
};
</script>

<style scoped>
.notification-message-block {
  min-height: 90px;
  min-width: 280px;
  width: 300px;
  display: flex;
  flex-direction: column;
}

.sub-card-wrapper {
  height: 100%;
  min-height: 90px;
  display: flex;
  flex-direction: column;
}

.card-container {
  height: 100%;
  min-height: 90px;
  display: flex;
  flex-direction: column;
}

.content-container {
  min-height: 90px;
  height: 100%;
  justify-content: space-between;
}

.top-section {
  padding-top: 15px;
  flex: 1;
}

.notification-message-block.base-card-wrapper {
  box-shadow: none !important;
}

.notification-message-block .base-card-wrapper {
  box-shadow: none !important;
}

</style>